import React from 'react';
import '../../../components/shared/Hero.css'; 

function Hero() {
  return (
    <section className="Sect">
      <img src="/Logo&Cloth/img with blur.png" alt="Curtain" className="Sect-img" />
      <div className="Sect-text">
        <img src="/Logo&Cloth/pic1.png" alt="Curtain" className="logo" />
        <h1>Quotation</h1>
        <p>Get your custom quote today</p>
        
      </div>
    </section>
  );
}

export default Hero;